import React, { useState, useRef } from "react";
import { Link, withRouter } from "react-router-dom";
import { FaLock, FaSms, FaUser, FaArrowLeft } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { emptyCart, removeUser } from "../../Redux/Actions";
import { Config } from "../../Config";
import Spinner from "../../components/Spinner/Spinner";
import LogoImage from "../../assets/images/logo.png";
import "./Forgot.scss";
import "./Responsive.scss";

const Forgot = (props) => {
  const [phone, setPhone] = useState("");
  const [smsCode, setSmsCode] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [activeForgot, setActiveForgot] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [recaptcha, setRecaptcha] = useState("");
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const refRecaptcha = useRef(null);
  let changePass = false;
  if (
    props.location.state !== undefined &&
    props.location.state.changePass !== null &&
    props.location.state.changePass !== undefined
  ) {
    changePass = true;
  }

  const phoneHandler = (e) => {
    setPhone(e.target.value);
  };

  const smsCodeHandler = (e) => {
    setSmsCode(e.target.value);
  };

  const passwordHandler = (e) => {
    setPassword(e.target.value);
  };
  const passwordConfirmHandler = (e) => {
    setPasswordConfirm(e.target.value);
  };

  // const recaptchHandler = (recaptchaValue) => {
  //     setRecaptcha(recaptchaValue);
  // }

  // const expireRecaptcha = () => {
  //     setRecaptcha("");
  // }

  const ForgotHandler = () => {
    if (phone !== "") {
      if (!Config.checkMobileValidate(phone)) {
        toast.error("شماره تماس صحیح نمی باشد!");
      } else {
        setShowSpinner(true);
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        let raw = JSON.stringify({
          Phone: phone,
        });
        let requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
        fetch(Config.apiPath + "/forgotpassword", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === 200) {
              toast.success(<div>{result.messages}</div>);
              setActiveForgot(true);
              setShowSpinner(false);
            } else {
              toast.error(<div>{result.messages}</div>);
              setShowSpinner(false);
            }
          })
          .catch((error) => {
            setShowSpinner(false);
            // console.log(error);
          });
      }
    } else {
      setActiveForgot(false);
      toast.error("شماره تماس وارد نشده است!");
    }
  };

  const ForgotPasswordHandler = () => {
    setShowSpinner(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify({
      UserName: phone,
      ActiveCode: smsCode,
      Password: password,
      PasswordConfirm: passwordConfirm,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/account/resetpassword", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          toast.success(<div>{result.messages}</div>);
          toast.info("لطفا مجددا وارد حساب کاربری خود شوید");
          setShowSpinner(false);
          if (dispatch(removeUser(user[0]))) {
            dispatch(emptyCart(cart));
            document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
          }
          setTimeout(() => {
            props.history.push("/login");
          }, 5000);
        } else {
          setShowSpinner(false);
          toast.error(<div>{result.messages}</div>);
        }
      })
      .catch((error) => {
        setShowSpinner(false);
        // console.log(error);
      });
  };

  const mobileKeyDown = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      ForgotHandler();
    }
  };

  const recoveryKeyDown = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      ForgotPasswordHandler();
    }
  };

  const goBackHandler = () => {
    props.history.push("/");
  };

  return (
    <section className="loginWrapper">
      <Helmet>
        {/* <title>ایران رگالو | بازیابی رمز عبور</title> */}
        <title>{Config.helmetTitle} | بازیابی رمز عبور</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="rightSide">
        <span className="goBack" onClick={goBackHandler}>
          <FaArrowLeft />
          &nbsp;صفحه اصلی
        </span>
        <div className="logo">
          <Link to="/">
            <img src={LogoImage} alt="logo" />
          </Link>
          <p className="pageTitle">{changePass ? "تغییر کلمه عبور پیامکی" : "بازیابی کلمه عبور"}</p>
        </div>
        {!activeForgot ? (
          <div className="formWrapper">
            <div className="formGroup">
              <div className="caption">
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => phoneHandler(e)}
                  onKeyPress={mobileKeyDown}
                  id="phone"
                  placeholder=""
                />
                <span className="placeholder">شماره تماس</span>
                <FaUser className="loginInputIcon" />
              </div>
            </div>
            <div className="formGroup">
              <ReCAPTCHA size="invisible" sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt" ref={refRecaptcha} />
              {/* <ReCAPTCHA size="invisible" sitekey="6Lfgov0bAAAAAFGd8c6ALNbuFDyrElRKdUukingY" onChange={recaptchHandler} onExpired={expireRecaptcha} /> */}
            </div>
            <div className="formGroup">
              <button className="btnLogin" onClick={ForgotHandler}>
                {showSpinner ? <Spinner color="#fff" /> : "ارسال"}
              </button>
            </div>

            <div className="formGroup">
              <p>
                بازگشت به حساب کاربری{" "}
                <Link to="/login" className="link">
                  وارد شوید
                </Link>
              </p>
            </div>
          </div>
        ) : (
          <div className="formWrapper">
            <div className="formGroup">
              <div className="caption">
                <input type="text" value={phone} onChange={(e) => phoneHandler(e)} id="phone" placeholder="" />
                <span className="placeholder">شماره تماس</span>
                <FaUser className="loginInputIcon" />
              </div>
            </div>
            <div className="formGroup">
              <div className="caption">
                <input type="text" value={smsCode} onChange={(e) => smsCodeHandler(e)} id="smsCode" placeholder="" />
                <span className="placeholder">کد پیامکی</span>
                <FaSms className="loginInputIcon" />
              </div>
            </div>
            <div className="formGroup">
              <div className="caption">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => passwordHandler(e)}
                  id="password"
                  placeholder=""
                />
                <span className="placeholder">کلمه عبور</span>
                <FaLock className="loginInputIcon" />
              </div>
            </div>
            <div className="formGroup">
              <div className="caption">
                <input
                  type="password"
                  value={passwordConfirm}
                  onChange={(e) => passwordConfirmHandler(e)}
                  onKeyPress={recoveryKeyDown}
                  id="passwordConfirm"
                  placeholder=""
                />
                <span className="placeholder">تکرار کلمه عبور</span>
                <FaLock className="loginInputIcon" />
              </div>
            </div>
            <div className="formGroup">
              <ReCAPTCHA size="invisible" sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt" ref={refRecaptcha} />
              {/* <ReCAPTCHA size="invisible" sitekey="6Lfgov0bAAAAAFGd8c6ALNbuFDyrElRKdUukingY" onChange={recaptchHandler} onExpired={expireRecaptcha} /> */}
            </div>
            <div className="formGroup">
              <button className="btnLogin" onClick={ForgotPasswordHandler}>
                {showSpinner ? <Spinner color="#fff" /> : <>{changePass ? "تغییر کلمه عبور" : "بازیابی کلمه عبور"}</>}
              </button>
            </div>

            <div className="formGroup">
              <p>
                بازگشت به حساب کاربری{" "}
                <Link to="/login" className="link">
                  وارد شوید
                </Link>
              </p>
            </div>
          </div>
        )}
      </div>
      <div className="leftSide"></div>
    </section>
  );
};

export default React.memo(withRouter(Forgot));
